// 首次创建数字人
export const SECOND_CREATE_CHARACTER = 'huibo_digital_anchor_first_create_character';

// 首次进入数字人
export const SECOND_ENTERED_CHARACTER = 'huibo_digital_anchor_first_enter_character';

// 数字人页面顶部tips
export const CHARACTER_TIPS_POPOVER = 'huibo_digital_anchor_character_tips_popover';

// 首次进入创建剧本-》全部数字人
export const CHARACTER_TOUR_OPEN = 'huibo_digital_anchor_character_first_tour_open';

export const CHARACTER_RULE_1 = 'https://huibo-data.cdn.bcebos.com/upload/0c95c3e28b0422967dd218dee1e146cd.pdf';